import { render, staticRenderFns } from "./sellFund.vue?vue&type=template&id=f2d78046"
import script from "./sellFund.vue?vue&type=script&lang=js"
export * from "./sellFund.vue?vue&type=script&lang=js"
import style0 from "./sellFund.vue?vue&type=style&index=0&id=f2d78046&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports